import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

@Component({
    selector: 'app-state-wise-expenditure-view',
    templateUrl: './state-wise-expenditure-view.component.html',
    styleUrls: ['./state-wise-expenditure-view.component.scss'],
    standalone: false
})
export class StateWiseExpenditureViewComponent implements OnInit {
  readonly columns: TableColumn[] = [
    { field: 'stateName', header: 'State Name' },
    { field: 'stampType', header: 'stampType' },
    { field: 'status', header: 'Status' },
    { field: 'denomination', header: 'Denomination' },
    { field: 'month', header: 'Month' },
    { field: 'consumtionDate', header: 'Consumtion Date' },
    { field: 'cetificateNumber', header: 'Cetificate Number' },
  ];

  states: any;
  selectedState:any;
  amountbalance= '2.5cr';
  selectedDate: any;
  expenditure: any=[];
  denomination:any =[];
  selectedDenomination!: number ;
  displayBranch! : any ;
  constructor(private storageService:StorageService,private router: Router ,private exportExcelService:ExportExcelService,private userDashboardService:UserDashboardService,private cookieService: CookieService) { 
    this.userDashboardService.getBranchList().subscribe((res:any)=>{
      this.states = res['content']
      this.displayBranch = this.storageService.getBranch() || null;
      this.displayBranch = this.displayBranch.name;
      
    
  })
  this.denomination =
  [
    {label: 10, value: 10},
    {label: 100, value: 100},
    {label: 50, value: 50},
    {label: 1000, value: 100},
    {label: 20, value: 20},
];
  this.expenditure= [
    {stateName: 'Maharashtra', cetificateNumber:12345,
     status:'Avaible',denomination:100, month:'October', stampType:'PHYSTAMP'
     ,consumtionDate:'23/03/23' },
     {stateName: 'Maharashtra', cetificateNumber:34566,
     status:'Used',denomination:100, month:'November', stampType:'PHYSTAMP'
     ,consumtionDate:'23/03/23' },
     {stateName: 'Maharashtra',  cetificateNumber:456576,
     status:'Used',denomination:100, month:'January', stampType:'PHYSTAMP'
     ,consumtionDate:'23/03/23' },
     {stateName: 'Maharashtra',  cetificateNumber:56662,
     status:'Used',denomination:100, month:'February', stampType:'PHYSTAMP'
     ,consumtionDate:'23/03/23' },
     {stateName: 'Maharashtra', cetificateNumber:78964,
     status:'Used',denomination:100, month:'July', stampType:'PHYSTAMP'
     ,consumtionDate:'23/03/23' },
     {stateName: 'Maharashtra', cetificateNumber:84746,
     status:'Used',denomination:100, month:'Aprial', stampType:'PHYSTAMP'
     ,consumtionDate:'23/03/23' },
    
    ];
  }

  ngOnInit(): void {
  }

  gotoDashboard(){
    this.router.navigate(['doqfy/dashboard']);
  }

  export(){
    this.exportExcelService.convertToExcel(this.expenditure,'expenditure');
  }
  getSelected(){
    this.cookieService.set('BranchName', this.selectedState);
  this.storageService.setBranch(this.selectedState)
  }
}
